import { Controller } from "@hotwired/stimulus";

// Expand / collapse a creator's accounts, and all of them at once.
//
// Progressive enhancement only: every row is in the DOM, and open/closed is a
// class on the <tbody> group. Without JS the groups render open (see
// .roster-group in profile_roster.scss), so nothing becomes unreachable.
export default class extends Controller {
  static targets = ["toggleAll"];

  toggle(event) {
    // Never swallow a click on a link or button inside the row.
    if (event.target.closest("a, button")) return;

    const group = event.currentTarget.closest(".roster-group");
    if (!group) return;

    const open = group.classList.toggle("is-open");
    event.currentTarget.setAttribute("aria-expanded", String(open));
    this.syncToggleAll();
  }

  toggleOnKey(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    this.toggle(event);
  }

  // One button, two jobs: if anything is still closed it expands everything,
  // otherwise it collapses everything. That's one less control than a separate
  // Expand / Collapse pair, and it always does the thing you can see you want.
  toggleAll() {
    const groups = this.groups;
    if (!groups.length) return;

    const open = groups.some((g) => !g.classList.contains("is-open"));
    groups.forEach((group) => {
      group.classList.toggle("is-open", open);
      const row = group.querySelector(".roster-row--creator");
      if (row) row.setAttribute("aria-expanded", String(open));
    });
    this.syncToggleAll();
  }

  get groups() {
    return Array.from(this.element.querySelectorAll(".roster-group"));
  }

  // Keep the master chevron honest after an individual row is toggled. It
  // rotates exactly like the row chevrons it sits above — same affordance, one
  // level up — so its state needs no words.
  syncToggleAll() {
    if (!this.hasToggleAllTarget) return;

    const allOpen = this.groups.every((g) => g.classList.contains("is-open"));
    this.toggleAllTarget.classList.toggle("is-open", allOpen);
    this.toggleAllTarget.setAttribute("aria-expanded", String(allOpen));
    this.toggleAllTarget.setAttribute(
      "title",
      allOpen ? "Collapse all creators" : "Expand all creators"
    );
  }
}
